export default __webpack_public_path__ + "static/media/testimony_student_six.c931bcd0.png";